module.exports = __webpack_public_path__ + "img/head-shoulders_hover.6a537a50.png";